import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentService } from './payment.service';
import { getCountryApiUrl } from 'src/app/helpers/country-api.helper';


@Injectable({
  providedIn: 'root'
})

/**
 * Servicio encargado de manejar las peticiones relacionadas con las plantillas
 * al backend. Permite obtener el contenido de una plantilla por su ID.
 */

export class PlantillaService {

  // URL base del backend, obtenida desde las variables de entorno de Angular según el país guardado.
  private get APIURL(): string {
    return getCountryApiUrl('api');
  }

  constructor(private http: HttpClient, public _paymentService: PaymentService) { }

  // Se Obtiene una plantilla específica desde el backend usando su ID.
  obtenerPlantillaPorId(id: number, channel: any): Observable<any> {
    const bearerToken = this._paymentService.getAuthToken();
    // Realiza una petición HTTP GET al endpoint /plantillas/{id}
    // para obtener la información de la plantilla correspondiente.
    return this.http.get<any>(`${this.APIURL}/plantillas/${id}?channel=${channel}`, { 
      headers: new HttpHeaders({ 
        'Authorization': `Bearer ${bearerToken}` 
      }) 
    });
  }

}
